// Generated by GitHub Copilot
import { sharedProfileIdentity } from "../../shared/profileIdentity";

export const siteConfig = {
  identity: {
    name: "(Venkat Sampath Siva) Ram Prakash Dhulipudi | dragon",
    heading: sharedProfileIdentity.headline,
    location: sharedProfileIdentity.location,
    summary:
      "I build production AI systems and scalable frontend platforms with a strong focus on trust, observability, and shipping velocity.",
    roles: ["Data Scientist", "ML Engineer", "React Architect", "GenAI Builder"],
    achievements: [
      {
        value: "91%",
        label: "Workflow automation coverage",
        evidence: "Autonomous prioritization and exception routing across multi-agent workflows.",
        projectUrl: "https://github.com/Ramdragneel01/autonomous-workflow-optimization-agents",
        projectLabel: "View project",
      },
      {
        value: "89%",
        label: "Model recommendation precision",
        evidence: "Dataset diagnostics and ranking automation improved model fit selection.",
        projectUrl: "https://github.com/Ramdragneel01/automated-ml-prediction-annotation-system",
        projectLabel: "View project",
      },
      {
        value: "93%",
        label: "Annotation efficiency",
        evidence: "Pre-label plus correction loops accelerated computer-vision annotation throughput.",
        projectUrl: "https://github.com/Ramdragneel01/automated-ml-prediction-annotation-system",
        projectLabel: "View project",
      },
      {
        value: "2-5 days",
        label: "Collaboration response window",
        evidence: "Best-effort reply window for project-fit discussions and technical collaboration.",
        projectUrl: "https://github.com/Ramdragneel01/dragon-portfolio",
        projectLabel: "View portfolio",
      },
    ],
  },
  sections: [
    { id: "hero", component: "Hero", enabled: true },
    { id: "projects", component: "Projects", enabled: true },
    { id: "about", component: "About", enabled: true },
    { id: "insights", component: "Insights", enabled: true },
    { id: "contact", component: "Contact", enabled: true },
  ],
  projects: {
    title: "Projects",
    subtitle:
      "Curated STAR case studies with measurable impact cards, release radar, maturity tags, and live GitHub engineering projects.",
  },
  about: {
    title: "About",
    summary:
      "I design trustworthy AI and ML products with production observability, resilient architecture, and measurable business outcomes.",
    paragraphs: sharedProfileIdentity.aboutParagraphs,
    skills: [
      { name: "Python", level: 95 },
      { name: "Machine Learning", level: 94 },
      { name: "Artificial Intelligence", level: 93 },
      { name: "React", level: 91 },
      { name: "Micro-Frontend Architecture", level: 89 },
    ],
  },
  contact: {
    title: "Contact",
    submitButtonLabel: "Send Message",
    placeholders: {
      name: "Your name",
      email: "Your email",
      message: "Your message",
    },
    statuses: {
      sending: "Sending...",
      success: "Message sent successfully.",
      failure: "Could not send message right now.",
    },
    collaboration: {
      title: "Open To Collaborate",
      summary:
        "I collaborate on high-signal AI and frontend platform work where reliability, observability, and measurable delivery outcomes matter.",
      topics: [
        "Trustworthy RAG evaluation and benchmark design",
        "MLOps reliability and observability loops",
        "Enterprise micro-frontend hardening and release governance",
      ],
      availability: [sharedProfileIdentity.location, "Remote collaboration", "Project and platform engagements"],
      responseExpectation: "Best-effort response within 2 to 5 business days.",
    },
  },
  chat: {
    enabled: true,
    title: "Dragon Assistant",
    welcomeMessage:
      "Are you here for hiring or just browsing? Select a mode first so I can tailor my responses.",
    placeholder: "Ask a specific question about Ram's portfolio...",
    systemPrompt:
      "You are a concise assistant for Ram Prakash Dhulipudi's portfolio. Prioritize factual project summaries and practical impact.",
  },
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || "/api",
  },
};
